var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "w100" },
    [
      _c(
        "w-container",
        [
          _c(
            "div",
            { staticClass: "filters" },
            [
              _c("w-spacer"),
              _c("w-input", {
                attrs: {
                  "icon-left": "file-invoice",
                  placeholder: _vm.$ct("document-nr"),
                },
                on: {
                  blur: function ($event) {
                    return _vm.fetchIfSaleNrChanged()
                  },
                  keydown: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.fetch()
                  },
                },
                model: {
                  value: _vm.saleNr,
                  callback: function ($$v) {
                    _vm.saleNr = $$v
                  },
                  expression: "saleNr",
                },
              }),
              _c("w-date-picker", {
                attrs: { placeholder: _vm.$ct("common.from"), nullable: "" },
                model: {
                  value: _vm.fromDate,
                  callback: function ($$v) {
                    _vm.fromDate = $$v
                  },
                  expression: "fromDate",
                },
              }),
              _c("w-date-picker", {
                attrs: { placeholder: _vm.$ct("common.till"), nullable: "" },
                model: {
                  value: _vm.tillDate,
                  callback: function ($$v) {
                    _vm.tillDate = $$v
                  },
                  expression: "tillDate",
                },
              }),
            ],
            1
          ),
          _c("w-data-table", {
            staticClass: "grow shrink table",
            attrs: {
              columns: _vm.columns,
              items: _vm.items,
              compare: _vm.compareFunc,
              "column-resize-handle": "",
              "order-column": _vm.paginationData.orderBy,
              "order-direction": _vm.paginationData.orderDirection == "ASC",
            },
            on: {
              scroll: function ($event) {
                return _vm.onScroll($event)
              },
              order: function ($event) {
                return _vm.onOrder($event)
              },
            },
          }),
          _c(
            "w-scroll-view",
            { staticClass: "bottom-row", attrs: { x: "", y: false } },
            [
              _c("div", { staticClass: "rows-count" }, [
                _vm._v(
                  _vm._s(
                    _vm.$ctc("components.browse.total", _vm.count, {
                      amount: _vm.count,
                    })
                  )
                ),
              ]),
              _c("w-spacer"),
              _vm._l(_vm.totals, function (total, i) {
                return _c("w-chip", { key: i, attrs: { active: "" } }, [
                  _vm._v(
                    _vm._s(_vm.$ctc("common.location", i + 1)) +
                      ": " +
                      _vm._s(total)
                  ),
                ])
              }),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }